// extracted by css-extract-rspack-plugin
export default {"app":"QXgKDV","show":"UULqxD","page":"QvSDJv","subPage":"enmIjC","pageRegistry":"Z3Rj0j","mask":"HCJ7U2"};